import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DragonTribeGameConfig} from "../DragonTribeGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class SymbolWinAnimation extends BaseView {

    private _layer: PIXI.Container;
    protected _strokeAnimations: MultiSprites[][] = [];
    protected _fireExplosions: TimelineSprite[][] =[];
    protected _stoneExplosions: TimelineSprite[][] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.BET_WAYS.name);
    }
    protected addEventListeners():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.resetAnimation());
    }

    protected initAnimations(): void {
        this._fireExplosions = [];
        this._strokeAnimations = [];
        this._stoneExplosions = [];
        for (let i: number = 0; i < 6; i++) {
            const reelAnimations: MultiSprites[] = [];
            const fireExplosions: TimelineSprite[] = [];
            const stoneExplosions: TimelineSprite[] = [];
            for (let j: number = 0; j < 6; j++) {
                const strokeAnimation = new MultiSprites({
                    1: {
                        textures: GameResources.getTextures("symWin1"),
                        anchor: [0.5, 0]
                    },
                    4: {
                        textures: GameResources.getTextures("symWin4"),
                        anchor: [0.5, 0.5]
                    },
                    5: {
                        textures: GameResources.getTextures("symWin5"),
                        anchor: [0.5, 0.5]
                    },
                    6: {
                        textures: GameResources.getTextures("symWin6"),
                        anchor: [0.5, 0.5]
                    }
                });
                const fireExplosion = new TimelineSprite(GameResources.getTextures("symbolFireExplosion"));
                fireExplosion.anchor.set(0.5, 0.5);
                fireExplosion.blendMode = PIXI.BLEND_MODES.ADD;

                const stoneExplosion = new TimelineSprite(GameResources.getTextures("symbolStoneExplosion"));
                stoneExplosion.anchor.set(0.5, 0.5);

                reelAnimations.push(strokeAnimation);
                fireExplosions.push(fireExplosion);
                stoneExplosions.push(stoneExplosion);
            }
            this._strokeAnimations.push(reelAnimations);
            this._fireExplosions.push(fireExplosions);
            this._stoneExplosions.push(stoneExplosions);
        }
    }

    public playStoneExplosionAnimation(reel: number, symbol: number): TimelineLite {
        const stoneExplosion: TimelineSprite = this._stoneExplosions[reel][symbol];
        const position: number[] = Helper.getSymbolPositions(reel, symbol, true);
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                stoneExplosion.hide();
                this._layer.addChild(stoneExplosion);
                stoneExplosion.position.set(position[0], position[1]);
            },
            stoneExplosion.getAnimationAutoShowHide(true, true)
        ]);
        return tl;
    }

    public playStrokeAnimation(reel: number, symbol: number, fullSize:boolean): TimelineLite {
        const symSize: number = (fullSize?1:510 /(Reels.getSymbol(reel, symbol)!.symHeight));
        const strokeAnimation: TimelineSprite = (this._strokeAnimations[reel][symbol]).sprites[symSize];
        const position: number[] = Helper.getSymbolPositions(reel, symbol, true);

        if(fullSize){
            position[1] = GameConfig.instance.REEL_AREA_POS_Y + DragonTribeGameConfig.instance.REEL_AREA_TOP-70;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._layer.addChild(strokeAnimation);
                strokeAnimation.position.set(position[0], position[1]);
                strokeAnimation.blendMode = PIXI.BLEND_MODES.ADD;
            },
            strokeAnimation.getAnimationAutoShowHide(true, true)
        ]);
        return tl;
    }

    public playWinExplodeAnimation(reel: number, symbol: number, fullSize:boolean): TimelineLite {
        const fireExplosion: TimelineSprite = this._fireExplosions[reel][symbol];
        const position: number[] = Helper.getSymbolPositions(reel, symbol, true);
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                fireExplosion.hide();
                this._layer.addChild(fireExplosion);
                fireExplosion.position.set(position[0], position[1]);
            },
            fireExplosion.getAnimationAutoShowHide(true, true)
        ]);
        return tl;
    }

    public resetAnimation(): void {
        this._fireExplosions.forEach((explosions: TimelineSprite[]) => {
            explosions.forEach((explosion: TimelineSprite) => {
                this._layer.removeChild(explosion);
                explosion.hide()
            });
        });

        this._stoneExplosions.forEach((explosions: TimelineSprite[]) => {
            explosions.forEach((explosion: TimelineSprite) => {
                this._layer.removeChild(explosion);
                explosion.hide()
            });
        });

        this._strokeAnimations.forEach((reelAnimations: MultiSprites[]) => {
            reelAnimations.forEach((strokeAnimation: MultiSprites) => {
                for (let name in strokeAnimation.sprites) {
                    const sprite: TimelineSprite = strokeAnimation.sprites[name];
                        this._layer.removeChild(sprite);
                        sprite.hide();
                }
            });
        });
    }
}